module.exports = __webpack_public_path__ + "static/media/img3.45b112cd.jpg";